import { roles } from "../roles";

export function getQuestionandAnswersetsFromJson(content) {
  for (const question of content.Questions) {
    splitKeysIntoPrimaryAndSub(question);

    splitQuestionandAnswer(question);
  }
  const questionsPrelim = [...content.Questions];
  trimKeysInQuestion(questionsPrelim);
  custValsIntoArray(questionsPrelim);

  return stratifyQuestionsByRole(questionsPrelim);
}

export function stratifyQuestionsByRole(questionsPrelim) {
  const questionsByRoles = {};
  const rolesz = roles;
  const attrsToPass = new Set([
    "Input Type",
    "custVals",
    "Questions",
    "Category",
    "AnswerSet",
    "Resmain",
    "Ressub",
    "Reslink",
  ]);

  for (const question of questionsPrelim) {
    for (const key in question) {
      if (attrsToPass.has(key)) continue;

      const idx = question[key] - 1;
      if (!questionsByRoles[key]) questionsByRoles[key] = [];

      questionsByRoles[key][idx] = { ...question };

      for (const role of rolesz) {
        delete questionsByRoles[key][idx][role];
      }
    }
  }

  const retThis = {};
  for (const role in questionsByRoles) {
    if (!retThis[role]) retThis[role] = [];
    for (const {
      Questions,
      Answers,
      custVals,
      Category,
      Resmain,
      Ressub,
      Reslink,
    } of questionsByRoles[role]) {
      retThis[role].push({
        questionSet: Questions,
        answerSet: Answers,
        custVals,
        NegCopy: Resmain,
        LinkText: Ressub,
        NegLink: Reslink,
        headerSet: Category,
      });
    }
  }

  return retThis;
}

export function custValsIntoArray(questionsPrelim, seperator) {
  for (let question of questionsPrelim) {
    question.custVals = question.custVals.split(",").map((v) => +v);
  }
}

export function trimKeysInQuestion(arrQuestions) {
  for (const question of arrQuestions) {
    for (const attr in question) {
      if (attr.trim() === attr) continue;
      delete Object.assign(question, { [attr.trim()]: question[attr] })[attr];
    }
  }
}

export function splitQuestionandAnswer(questionAnswer) {
  const questionsObj = questionAnswer.questionSet;
  let answerArr = questionAnswer.Answers;
  /*
  for (let language in questionsObj) {
    let answerArr = questionsObj[language];
    !questionAnswer.AnswerSet
      ? (questionAnswer.AnswerSet = { [language]: [...answerArr] })
      : (questionAnswer.AnswerSet[language] = [...answerArr]);
  }
  */
}

export function splitKeysIntoPrimaryAndSub(originalKey) {
  for (const key in originalKey) {
    if (key.includes(":")) {
      let [pkey, subkey] = key.split(":");

      pkey = pkey.trim();
      subkey = subkey.trim();

      !originalKey[pkey]
        ? (originalKey[pkey] = { [subkey]: originalKey[key] })
        : (originalKey[pkey][subkey] = originalKey[key]);

      delete originalKey[key];
    }
  }
}
